import View from './View';
import previewView from './previewView.js';
class ResultsView extends View {
  _parentEl = document.querySelector('.results');
  _errorMessage = 'No Recipes found for your query, Please ty again ';
  _message = '';

  _generateMarkup() {
    return this._data.map(result => previewView.render(result, false)).join('');
  }
}

export default new ResultsView();
